<template>
	<fragment>
		<!-- Customer view -->
		<template v-if="!isStaff">
			<div class="contentColumn contentColumnPaddingRight">
				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Consignor</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.owner_name }}</span>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Consignor's Mailing Address</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.mailing_address }}</span>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Consignor's Phone</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.owner_phone }}</span>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Consignor's Email</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.owner_email }}</span>
					</div>
				</div>
			</div>

			<div class="contentColumn contentColumnPaddingLeft">
				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Other Contact Name</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.agent_name }}</span>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Other Contact Mailing Address</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.agent_address }}</span>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Proceeds To</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ contract.proceeds_to }}</span>
					</div>
				</div>
			</div>

			<div class="contentBlock marginBottomSmall">
				<div class="contentBlock">
					<span class="colorGrey">Pick-up Date &amp; Location</span>
					<br />
				</div>
				<div class="contentBlock">
					<span class="value contentBlock">{{ pickupLocation }}</span>
				</div>
			</div>
		</template>

		<!-- Staff view -->
		<template v-if="isStaff">
			<!-- Staff view when editable -->
			<template v-if="isEditable(true)">
				<div class="contentColumn contentColumnPaddingRight">
					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.owner_name"
								maxlength="250"
								name="consignor"
								type="text"
								tabindex="1"
								:disabled="sentOrSigned"
							/>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor's Mailing Address</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.mailing_address"
								maxlength="250"
								name="consignors_mailing_address"
								type="text"
								tabindex="2"
								:disabled="sentOrSigned"
							/>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor's Phone</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.owner_phone"
								maxlength="250"
								name="consignors_phone"
								type="text"
								tabindex="3"
								:disabled="sentOrSigned"
							/>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor's Email</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.owner_email"
								maxlength="250"
								name="consignors_email"
								type="text"
								tabindex="4"
								:disabled="sentOrSigned"
							/>
						</div>
					</div>
				</div>

				<div class="contentColumn contentColumnPaddingLeft">
					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Other Contact Name</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.agent_name"
								maxlength="250"
								name="consignors_agent"
								type="text"
								placeholder="(if applicable)"
								tabindex="5"
							/>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Other Contact Mailing Address</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.agent_address"
								maxlength="250"
								name="consignors_agents_mailing_address"
								type="text"
								placeholder="(if applicable)"
								tabindex="6"
							/>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Proceeds To</span>
							<br />
						</div>
						<div class="contentBlock">
							<input
								v-model="contract.proceeds_to"
								maxlength="250"
								name="proceeds_to"
								type="text"
								tabindex="7"
								:disabled="sentOrSigned"
							/>
						</div>
					</div>

					<div
						v-if="firstTimeConsignor"
						class="contentBlock marginBottomSmall"
					>
						<div class="contentBlock">
							<span class="colorGrey">How did the consignor hear about us?</span>
							<br />
						</div>
						<div class="contentBlock">
							<select
								v-model="contract.heard_about"
								name="heard_about"
								class="heardAbout"
								tabindex="10"
							>
								<option
									value=""
									disabled
								>
									Select one
								</option>
								<option
									v-for="(value, key) in heardAboutOptions"
									:key="key"
									:value="key"
								>
									{{ value }}
								</option>
							</select>
						</div>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Pick-up Date &amp; Location</span>
						<br />
					</div>
					<div class="contentBlock">
						<input
							v-model="contract.pickup"
							maxlength="250"
							name="pickup"
							type="text"
							placeholder="(if different from Consignor's Mailing Address)"
							tabindex="9"
						/>
					</div>
				</div>
			</template>

			<!-- Staff view when not editable -->
			<template v-else>
				<div class="contentColumn contentColumnPaddingRight">
					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.owner_name }}</span>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor's Mailing Address</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.mailing_address }}</span>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor's Phone</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.owner_phone }}</span>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Consignor's Email</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.owner_email }}</span>
						</div>
					</div>
				</div>

				<div class="contentColumn contentColumnPaddingLeft">
					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Other Contact Name</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.agent_name }}</span>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Other Contact Mailing Address</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.agent_address }}</span>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">Proceeds To</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">{{ contract.proceeds_to }}</span>
						</div>
					</div>

					<div class="contentBlock marginBottomSmall">
						<div class="contentBlock">
							<span class="colorGrey">How did the consignor hear about us?</span>
							<br />
						</div>
						<div class="contentBlock">
							<span class="value contentBlock">
								{{ heardAboutOptions[contract.heard_about] || 'N/A' }}
							</span>
						</div>
					</div>
				</div>

				<div class="contentBlock marginBottomSmall">
					<div class="contentBlock">
						<span class="colorGrey">Pick-up Date &amp; Location</span>
						<br />
					</div>
					<div class="contentBlock">
						<span class="value contentBlock">{{ pickupLocation }}</span>
					</div>
				</div>
			</template>
		</template>
	</fragment>
</template>

<script>
	import contractState from '../../../mixins/contractState'
	import { Fragment } from 'vue-frag'

	export default {
		name: 'ConsignorInfo',
		components: {
			Fragment
		},
		mixins: [contractState],
		props: {
			contract: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				heardAboutOptions: {
					radio: 'Radio',
					print: 'Print',
					internet: 'Internet',
					friend: 'Friend',
					unknown: 'Unknown'
				}
			}
		},
		computed: {
			/**
			 * The pickup location
			 * @returns {string} The pickup location
			 */
			pickupLocation() {
				return this.contract.pickup?.trim() || 'N/A'
			}
		},
		mounted() {}
	}
</script>

<style scoped></style>
